export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
  PROFILE: 'profile',
  PERMISSIONS: 'permissions',
  FEATURES: 'features',
  PROFILE_CACHE: 'optimus_profile_cache',
  AGENTS_CACHE: 'optimus_agents_list',
  AGENT_DETAIL_PREFIX: 'optimus_agent_detail',
  THEME: 'theme',
  REMEMBER_ME: 'remember_me',
} as const

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]
